import moment from 'moment';
import { TRIAL_EXPIRING_SOON_DAYS } from '../types/company';

const STORAGE_KEY_PREFIX = 'trialEndingModalShown';

export const getTrialEndingStorageKey = (companyId) => {
  const today = moment().format('YYYY-MM-DD');
  return `${STORAGE_KEY_PREFIX}_${companyId || 'default'}_${today}`;
};

export const wasTrialEndingModalShownToday = (companyId) => {
  try {
    return localStorage.getItem(getTrialEndingStorageKey(companyId)) === 'true';
  } catch {
    return false;
  }
};

export const markTrialEndingModalShownToday = (companyId) => {
  try {
    localStorage.setItem(getTrialEndingStorageKey(companyId), 'true');
  } catch {
    // localStorage indisponível
  }
};

/**
 * Decide se deve exibir o modal de trial acabando com base em user.trial.
 *
 * @param {import('../types/company').TrialInfo} trial - user.trial vindo do /auth/me
 * @returns {boolean}
 */
export const shouldShowTrialEndingModal = (trial) => {
  if (!trial || !trial.inTrial) return false;
  const daysLeft = typeof trial.daysRemaining === 'number' ? trial.daysRemaining : 0;
  return daysLeft <= TRIAL_EXPIRING_SOON_DAYS;
};
